import { labelsBPR } from 'constants/businessProcessLevels';
import { InfoButton } from './InfoButton';
import * as Styled from '../BusinessProcessTree.styled';

export const renderNodeByLevel = (node: any, level: number, token: any) => {
  const item = node.raw;

  const type = level === 0 ? 'process' : level === 1 ? 'risk' : 'control';

  return (
    <Styled.TreeNodeWrapper level={level}>
      <Styled.TreeLabel token={token}>{labelsBPR[level]}</Styled.TreeLabel>

      <Styled.TreeValue token={token} level={level}>
        {node.label}
        <InfoButton type={type} item={item} />
      </Styled.TreeValue>
    </Styled.TreeNodeWrapper>
  );
};
